import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import Seo from '../components/Seo';
import { api } from '../lib/api';

export default function BlogListPage() {
  const { data: posts = [], isLoading } = useQuery({
    queryKey: ['blogs'],
    queryFn: api.listBlogs,
  });

  const published = posts.filter((p) => p.status === 'published');

  return (
    <>
      <Seo title="Insights & Updates" description="Cleaning industry insights and Uclipse updates." />

      <section className="border-b border-slate-100 bg-slate-50 py-14">
        <div className="container-page max-w-3xl">
          <h1 className="font-display text-4xl font-bold">Insights</h1>
          <p className="mt-3 text-slate-600">News, technical notes, and case studies.</p>
        </div>
      </section>

      <section className="container-page py-12">
        {isLoading ? (
          <div className="py-20 text-center text-slate-500">Loading…</div>
        ) : published.length === 0 ? (
          <div className="py-20 text-center text-slate-500">No posts yet. Check back soon.</div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {published.map((p) => (
              <Link
                key={p.rowKey}
                to={`/blog/${p.rowKey}`}
                className={
                  p.pinned
                    ? 'card overflow-hidden ring-2 ring-brand-200 hover:shadow-lg md:col-span-2 md:grid md:grid-cols-2 lg:col-span-3'
                    : 'card overflow-hidden hover:shadow-lg'
                }
              >
                {p.coverImageUrl && (
                  <img
                    src={p.coverImageUrl}
                    alt={p.title}
                    className={p.pinned ? 'aspect-video h-full w-full object-cover' : 'aspect-video w-full object-cover'}
                  />
                )}
                <div className={p.pinned ? 'p-6 md:p-8' : 'p-5'}>
                  <div className="flex flex-wrap gap-1 text-xs">
                    {p.pinned && (
                      <span className="rounded-full bg-brand-600 px-2 py-0.5 font-semibold text-white">Pinned</span>
                    )}
                    {p.bodyHtmlHi && (
                      <span className="rounded-full bg-amber-50 px-2 py-0.5 text-amber-700">English · हिंदी</span>
                    )}
                    {p.tags.slice(0, 3).map((t) => (
                      <span key={t} className="rounded-full bg-brand-50 px-2 py-0.5 text-brand-700">
                        {t}
                      </span>
                    ))}
                  </div>
                  <h2 className={p.pinned ? 'mt-3 font-display text-2xl font-bold' : 'mt-2 font-display text-lg font-semibold'}>
                    {p.title}
                  </h2>
                  {p.excerpt && (
                    <p className={p.pinned ? 'mt-2 text-slate-600' : 'mt-1 line-clamp-3 text-sm text-slate-600'}>{p.excerpt}</p>
                  )}
                  {p.publishedAt && (
                    <div className="mt-3 text-xs text-slate-500">
                      {new Date(p.publishedAt).toLocaleDateString()}
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </>
  );
}
